import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { ClosingReportService } from '../closing-report.service';

@Injectable()
export class ClosingReportResolver implements Resolve<boolean> {
  constructor(private closingReportService: ClosingReportService) {}

  public resolve(): Observable<boolean> {
    return this.closingReportService.shouldShowClosingReports();
  }
}
